import React from "react";
import { Card, Divider, Stack, TextField, Typography } from "@mui/material";

/**
 * Ticket print text fields — same structure as before tab split (Access System settings).
 */
const AccessSystemTicketSettingsTab = ({
  values,
  errors,
  setFieldValue,
  handleBlur,
  linesHelp,
  t,
}) => (
  <Card sx={{ p: 2 }}>
    <Stack spacing={2}>
      <Typography variant="h6" fontWeight={700}>
        {t("pages.accessSystemSettings.printSettings.title", {
          defaultValue: "Nastavenie tlače",
        })}
      </Typography>
      <Divider />

      <TextField
        fullWidth
        multiline
        minRows={4}
        name="headerText"
        value={values.headerText}
        onChange={(e) => setFieldValue("headerText", e.target.value)}
        onBlur={handleBlur}
        label={t("pages.accessSystemSettings.printSettings.headerLines", {
          defaultValue: "Text pred lístkami",
        })}
        helperText={errors.headerText ? errors.headerText : linesHelp}
        error={Boolean(errors.headerText)}
      />

      <TextField
        fullWidth
        multiline
        minRows={4}
        name="footerText"
        value={values.footerText}
        onChange={(e) => setFieldValue("footerText", e.target.value)}
        onBlur={handleBlur}
        label={t("pages.accessSystemSettings.printSettings.footerLines", {
          defaultValue: "Text za lístkami",
        })}
        helperText={errors.footerText ? errors.footerText : linesHelp}
        error={Boolean(errors.footerText)}
      />
    </Stack>
  </Card>
);

export default AccessSystemTicketSettingsTab;
